var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"re-inp-box",class:_vm.getComponentClasses()},[_c(_vm.component,_vm._g(_vm._b({tag:"component",on:{"input":_vm.handleInput},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}},'component',_vm.getFieldProps(),false),_vm.getComponentListeners()))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }